import {
  IAPIDownloadMediaRequestModel,
  IAPIMediaItem,
} from "@mindmemobile/mm-shared-library";
import { url } from "../components/FundraiserAPIEndPoints";
import HttpService from "./HttpService";
import { Observable } from "rxjs";

class MediaService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_MINDME_MAIN_API
    );
  }

  downloadUnsplashImageByUrl(
    data: IAPIDownloadMediaRequestModel
  ): Observable<IAPIMediaItem[]> {
    return this.httpService.post<IAPIMediaItem[]>(
      url.downloadMediaToLibrary,
      data
    );
  }
}
export default new MediaService();
